import { useMemo } from "react";
import ServiceClient from "../ServiceClient";
import ServiceTransaction from "../ServiceTransaction";
import { useServiceClient } from "../ServiceClientContext";

interface Language {
  value: string;
  name: string;
}

interface Locale {
  value: string;
  name: string;
}

interface Voice {
  value: string;
  name: string;
}

interface GetLanguagesOutput {
  languages: Language[];
}

interface GetLanguageLocalesOutput {
  locales: Locale[];
}

interface GetLocaleVoicesOutput {
  voices: Voice[];
}

class ContentServiceClient {
  constructor(private serviceClient: ServiceClient) {}

  public async getContentLanguages(): Promise<ServiceTransaction<GetLanguagesOutput>> {
    const endPoint: string = "/content/Languages";
    return this.serviceClient.get(endPoint);
  }

  public async getContentLanguageLocales(language: string): Promise<ServiceTransaction<GetLanguageLocalesOutput>> {
    const endPoint: string = `/content/LanguageLocales?language=${encodeURIComponent(language)}`;
    return this.serviceClient.get(endPoint);
  }

  public async getContentLocaleVoices(locale: string): Promise<ServiceTransaction<GetLocaleVoicesOutput>> {
    const endPoint: string = `/content/LocaleVoices?locale=${encodeURIComponent(locale)}`;
    return this.serviceClient.get(endPoint);
  }
}

export type { Language, Locale, Voice, GetLanguagesOutput, GetLanguageLocalesOutput, GetLocaleVoicesOutput };
export default ContentServiceClient;

export function useContentServiceClient(): ContentServiceClient {
  const serviceClient = useServiceClient();
  return useMemo(() => new ContentServiceClient(serviceClient), [serviceClient]);
}
